<template>
  <div class="border rounded mt-2 mx-2">
    <div class="d-flex align-items-center mx-2 mt-2"
      :class="{ 'mb-2': isShowDetail }"
    >
      <img
        class="mx-2 avatar"
        :src="conversation.avatar"
      />
      <div class="flex-grow-1 mt-1">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-inline-flex align-items-center">
            <span class="fw-medium text-black d-inline-flex align-items-center"
              >{{ conversation.toName }}
              <img
                class="mx-2"
                src="@/assets/icons/zalo.svg"
              />
            </span>
            <span class="grey--text"
              >•
              {{
                moment(new Date(conversation.lastMessageTime)).format(
                  'HH:mm DD/MM/YYYY'
                )
              }}</span
            >
          </div>
          <div class="d-flex align-items-center gap-1">
            <el-button 
              :icon="isShowDetail ? 'icon-arrow1-up' : 'icon-arrow1-down'" 
              circle plain
              style="font-size: 28px; border: none; box-shadow: none;padding: 0;" 
              @click.stop="toggleDetail"
            >
            </el-button>
            <el-tooltip class="item" effect="dark" content="Nhắn tin qua Zalo" placement="top-start">
              <a
                :href="'https://zalo.salework.net/conversation/' + conversation.id"
                target="_blank"
                style="text-decoration: none;"
              >
                <el-button 
                  icon="el-icon-chat-line-round"
                  circle plain
                  style="font-size: 20px; border: none; box-shadow: none;padding: 0;" 
                >
                </el-button>
              </a>
            </el-tooltip>
          </div>
        </div>
        <div
          v-if="!isShowDetail"
          class="grey--text mb-2"
          @click.stop="() => {}"
        >
          {{ conversation.lastContent }}
        </div>
      </div>
    </div>
    <iframe
      @click.stop="() => {}"
      v-if="isShowDetail"
      class="framePreview"
      :src="conversationDetailUrl"
      id="iframeChat"
      width="100%"
      height="650"
    ></iframe>
    <div class="line"></div>
    <div class="my-2 px-2">
      Tài khoản nhắn tin : <span class="text-primary">{{ accountSwName }}</span>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/lib/http-common';
export default {
  data(){
    return{
      isShowDetail : false,
    }
  },
  props : {
    conversation : {
      type : Object,
      require : true
    },
    accountList : {
      type : Array,
      require : true
    }
  },
  computed : {
    accountSwName() {
      const account = this.accountList.find(
        (item) => item.accountId === this.conversation.accountId
      );
      return account ? (account.swName ? account.swName : account.zaloName) : '';
    },
    conversationDetailUrl() {
      return `https://zalo.salework.net/conversation?id=${this.conversation.id}`;
    }
  },
  methods : {
    toggleDetail() {
      this.isShowDetail = !this.isShowDetail;
      this.saveLog(this.isShowDetail ? "OPEN" : "CLOSE");
    },
    async saveLog(action) {
      try {
        await HTTP.post("/api/log-chat/save-log-chat", {
          action: action,
          conversation: this.conversation.id,
          type: "ZALO",
          sessionId: this.app.sessionId,
          displayName: this.conversation.swName || this.conversation.toName,
          phone: this.conversation.phone || "",
          channel: null
        });
      } catch (e) {
        console.error("Lỗi lưu log:", e);
      }
    },
    handleBeforeUnload() {
      this.saveLog("CLOSE");
    },
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    this.saveLog("CLOSE");
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }
}
</script>

<style scoped>
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: contain;
}
.line{
  height: 1px;
  background-color: #EAECF2;
}
.framePreview {
    margin-bottom: -5px;
    border-top:  thin solid #d3d7de;
}
</style>